"use client";

import React from "react";
import { Heading } from "@/components/ui/typography";

const steps = [
  {
    number: "1",
    color: "bg-[#E8473F]",
    title: "Strategy Consultation",
    description:
      "We review your company structure and compliance requirements.",
  },
  {
    number: "2",
    color: "bg-[#3DB87A]",
    title: "Setup or Transition Coordination",
    description:
      "We organise document access and prepare your records correctly.",
  },
  {
    number: "3",
    color: "bg-[#4F5BD5]",
    title: "Ongoing Support Managed for You",
    description:
      "Your company filings and compliance coordination stay handled moving forward.",
  },
];

export default function Steps({ heading = "Getting Started Takes 3 Steps" }: { heading?: string } = {}) {
  return (
    <section className="w-full bg-black py-[60px] lg:py-[80px] px-4 min-[1340px]:px-0">
      <div className="max-w-[1200px] mx-auto flex flex-col items-center gap-10 lg:gap-12">
        {/* TITLE */}
        <Heading as="h2" variant="sectionCentered">
          {heading}
        </Heading>

        {/* STEPS */}
        <div className="w-full flex flex-col gap-6">
          {/* CIRCLES ROW */}
          <div className="relative flex items-center justify-between w-full max-w-[860px] mx-auto px-[44px]">
            {/* Dashed line behind circles */}
            <div className="absolute inset-x-[88px] top-1/2 -translate-y-1/2 border-t-2 border-dashed border-white/10" />

            {steps.map((step) => (
              <div
                key={step.number}
                className={`relative z-10 w-[72px] h-[72px] rounded-full ${step.color} flex items-center justify-center shadow-md`}
              >
                <span className="text-white font-inter font-bold text-[28px] leading-none">
                  {step.number}
                </span>
              </div>
            ))}
          </div>

          {/* CARDS ROW */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 w-full">
            {steps.map((step) => (
              <div
                key={step.number}
                className="bg-[#0f1218] border border-white/10 rounded-2xl px-8 py-8 flex flex-col items-center gap-4 text-center"
              >
                <h3 className="font-inter font-bold text-white text-[17px] lg:text-[18px] leading-[130%]">
                  {step.title}
                </h3>
                <p className="font-inter text-white/70 text-[14px] lg:text-[15px] leading-[160%]">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <a
          href="https://calendly.com/d/cxy2-dy2-tqk/mutetaxes-consultation-call"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-[#335CFF] text-white font-inter font-medium text-[15px] px-7 py-3 rounded-xl hover:opacity-90 transition"
        >
          Book a Free Consultation
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.7965 9.99932L7.08398 6.28682L8.14448 5.22632L12.9175 9.99932L8.14448 14.7723L7.08398 13.7118L10.7965 9.99932Z" fill="white"/>
          </svg>
        </a>
      </div>
    </section>
  );
}
